import { useState } from 'react'

import { Box, Divider } from '@factorialco/deprecated-design-system'
import * as HoverCard from '@radix-ui/react-hover-card'
import { AnimatePresence } from 'framer-motion'

interface IHoverScheduleCardProps {
  header: React.ReactNode
  children: React.ReactNode
  content?: React.ReactNode
  moreContent?: React.ReactNode
  footer: React.ReactNode
}
const HoverScheduleCard = ({
  header,
  children,
  content,
  moreContent,
  footer,
}: IHoverScheduleCardProps) => {
  const [open, setOpen] = useState(false)

  return (
    <HoverCard.Root open={open} onOpenChange={setOpen}>
      <HoverCard.Trigger asChild>{children}</HoverCard.Trigger>
      <HoverCard.Portal forceMount>
        <AnimatePresence>
          {open && (
            <HoverCard.Content forceMount side="top" sideOffset={10} collisionPadding={10}>
              <HoverCard.Arrow width={12} height={8} fill="white" />
              <Box.Motion
                boxShadow="s100"
                borderRadius={{ all: 'abs012' }}
                background="overlayBackground"
                initial={{ pointerEvents: 'none', opacity: 0, y: 10 }}
                animate={{ pointerEvents: 'auto', opacity: 1, y: 0 }}
                exit={{ opacity: 0, pointerEvents: 'none' }}
                transition={{
                  duration: 0.3,
                }}
                width="s300"
                onClick={(e) => e.stopPropagation()}
                cursor="default"
              >
                <Box padding="s12">{header}</Box>
                <Divider />
                <Box
                  flexDirection="column"
                  gap="s12"
                  paddingY="s12"
                  background="grey100"
                  borderRadius={{ bottomLeft: 'abs012', bottomRight: 'abs012' }}
                >
                  {content && (
                    <>
                      <Box paddingX="s12">{content}</Box>
                      <Divider />
                    </>
                  )}

                  {moreContent && (
                    <>
                      <Box paddingX="s12">{moreContent}</Box>
                      <Divider />
                    </>
                  )}

                  <Box paddingX="s12">{footer}</Box>
                </Box>
              </Box.Motion>
            </HoverCard.Content>
          )}
        </AnimatePresence>
      </HoverCard.Portal>
    </HoverCard.Root>
  )
}

export default HoverScheduleCard
